export const styles = {
    iframeBackdropContainer: {
        backgroundColor: 'black',
        zIndex: '10000',
        opacity: ({ isVisible }) => (isVisible ? 1 : 0),
        transition: '0.5s ease-in-out',
        position: 'absolute',
        top: 0,
        width: '100%',
        height: '100%',
    },
    iframeContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        zIndex: '10000',
        left: '0%',
        top: '0%',
        opacity: ({ isVisible }) => (isVisible ? 1 : 0),
        transition: '0.5s ease-in-out',
    },
    iframeContainerBorder: {
        left: '5%',
        top: '5%',
        width: '90%',
        height: '90%',
    },
    registrationIframe: {
        width: '100%',
        height: '100%',
        borderWidth: '0px',
        opacity: ({ isVisible }) => (isVisible ? 1 : 0),
        transition: '0.5s ease-in-out',
    },
    closeButton: {
        cursor: 'pointer',
        width: '20px',
        height: '20px',
        position: 'absolute',
        top: '3%',
        right: '3%',
        opacity: ({ showCloseButton }) => (showCloseButton ? 1 : 0),
        transition: '0.5s ease-in-out',
    },
}
